import React from 'react';
import { cn } from '@/lib/utils';

/**
 * SectionLabel — small uppercase section divider used between dashboard
 * groupings ("Your Business", "Quick Actions", "Grow Your Business", etc.).
 *
 * Premium-polish update (Feb 2026): the inline class string
 *   `text-xs font-semibold text-gray-400 uppercase tracking-wider`
 * appeared in 15+ spots and rendered too faintly on the warm page
 * background. This component is a one-line wrapper that promotes the
 * label to a slightly darker gray-500 + tighter tracking so each group
 * earns its own visual anchor without becoming heavy.
 *
 * No prop or routing changes — drop-in replacement.
 */
export const SectionLabel = ({ children, className, ...rest }) => (
  <p
    className={cn(
      'text-[11px] font-semibold text-gray-500 uppercase tracking-[0.08em] mb-3',
      className
    )}
    {...rest}
  >
    {children}
  </p>
);

export default SectionLabel;
